export const ADD = 'ADD';
export const CLEAR_IMAGES = 'CLEAR_IMAGES';
export const SCREENSHOT_ERROR = 'SCREENSHOT_ERROR';
